import convertBytes from "./convertBytes";

class CompressorImage {
  constructor(file, options = {}) {
    if (!file) throw new Error('File is required!');
    this.file = file;

    this.sizes = {
      original: file?.size || 0,
      difference: 0,
      final: 0
    };

    this.options = Object.assign({
      width: 800,
      quality: 0.8,
      format: 'image/jpeg',
      unit: 'MB'
    }, options);
  };

  static validTypes = ["image/jpeg", "image/png", "image/webp"];

  static isValidImageType(file) {
    if (!file) return false;
    return this.validTypes.includes(file.type);
  }

  compress() {
    const options = this.options;
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          const maxWidth = options.width;
          const ratio = maxWidth / img.width;
          canvas.width = maxWidth;
          canvas.height = img.height * ratio;

          ctx?.drawImage(img, 0, 0, canvas.width, canvas.height);

          canvas.toBlob((blob) => {
            if (blob) {
              let blobUrl = URL.createObjectURL(blob);
              let blobSize = blob.size;
              const displaySizes = {};

              if (this.sizes.original < blobSize) {
                const blobOriginal = new Blob([this.file], { type: this.file.type });
                blobUrl = URL.createObjectURL(blobOriginal);
                blobSize = blobOriginal.size;
              }

              this.sizes.final = blobSize;
              this.sizes.difference = this.sizes.original - blobSize;

              for (const key in this.sizes) {
                const size = this.sizes[key];
                displaySizes[`${key}Display`] = convertBytes(size, this.options.unit);
              }

              resolve({
                file: blobUrl,
                sizes: {
                  ...this.sizes,
                  ...displaySizes
                },
              });
            } else {
              reject('Could not convert to Blob!');
            }
          }, options.format, options.quality);
        }
        img.src = event.target?.result;
        img.onerror = (error) => reject(error);
      };
      reader.onerror = (error) => reject(error);

      reader.readAsDataURL(this.file);
    });
  }
}

export default CompressorImage;